<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card">
      <template>
        <el-form size="small" @submit.native.prevent :inline="true">
          <div class="">
            <div>
              <el-form-item label="">
                <el-input class="inputWidth" v-model="searchForm.keyWords" placeholder="请输入订单编号、购买人、后台备注" @clear="handleClickSearch()" @keyup.enter.native="handleClickSearch"  clearable>
                  <template #suffix>
                    <i class="el-icon-search" @click="handleClickSearch"></i>
                  </template>
                </el-input>
              </el-form-item>
              <el-button size="small" style="margin-top: 2px" @click="handleClickReset">重置</el-button>
            </div>
          </div>
        </el-form>
        <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
          <el-table-column prop="id" align="center" label="序号" width="80"></el-table-column>
          <el-table-column prop="order_num" align="center" label="订单编号" min-width="150" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span class="template_color" @click="handleClickOrderNum(row)">{{row.order_num}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_id" align="center" label="产品名称" min-width="160" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-if="row.product && row.product.product_name">{{row.product.product_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="购买数量" min-width="100" show-overflow-tooltip	></el-table-column>
          <el-table-column prop="unit_price" align="center" label="单价" min-width="100" show-overflow-tooltip	></el-table-column>
          <el-table-column prop="price" align="center" label="总价" min-width="100" show-overflow-tooltip	></el-table-column>
          <el-table-column prop="pay_way" align="center" label="购买人" min-width="120" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-if="row.user && row.user.name">{{row.user.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_date" align="center" label="支付时间" min-width="140" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-text="convertToCurrentTimezone(row.pay_date,'/','datetime')"></span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_way" align="center" label="支付方式" min-width="120" show-overflow-tooltip	></el-table-column>
          <el-table-column   prop="start_date"  align="center"  label="有效期截至日"  min-width="320" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-if="row.start_date" v-text="convertToCurrentTimezone(row.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(row.end_date,'/','datetime')"></span>
            </template>
          </el-table-column>
          <el-table-column   prop="admin_note"  align="center"  label="后台备注"  min-width="160" show-overflow-tooltip	></el-table-column>
          <el-table-column   prop="admin"  align="center"  label="添加人"  min-width="120" show-overflow-tooltip	>
            <template slot-scope="{row}">
               <span v-if="row.admin && row.admin.name" v-text="row.admin.name"></span>
            </template>
          </el-table-column>
          <el-table-column prop="handle" align="center" fixed="right" label="操作" min-width="100" >
            <template slot-scope="{row}">
                <el-button type="text" size="small" @click="handleClickEdit(row)">编辑</el-button>
                <el-dropdown trigger="click" class="dropdown_more" >
                  <i class="el-icon-more"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleClickDel(row)" >删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </template>


      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pagination.pageNum"
                     :page-sizes="pagination.pageSizes"
                     :page-size="pagination.pageSize"
                     :layout="pagination.layout"
                     :total="pagination.total">
      </el-pagination>
    </el-card>
    <orderEdit :orderEditVisible.sync="orderEditVisible" v-if="orderEditVisible" :orderId="orderId"   @success="handleClickSearch"/>
  </div>
</template>

<script>
import { adminOrderList,adminOrderDel} from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
import orderEdit from './order_edit.vue'
export default {
  name: 'order',
  components: {
    orderEdit
  },
  data() {
    return {
      loading:false,
      tableData:[ ],
      tableHeight:'',
      searchForm:{
        keyWords:''
      },
      orderId:0,
      orderEditVisible:false
    }
  },

  mixins: [pagination],
  created() {
    //将计算的table高度赋值给table
    this.tableHeight = getTableHeight(260)
  },
  mounted() {
    this.getTableData()
    //窗口缩放时动态修改table的高度
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableHeight(210)
        //清除定时器
        this.resizeTimer = null
      }, 100)
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),
  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    getTableData() {
      this.loading = true
      let postData = {
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        keyword:this.searchForm.keyWords
      }
      adminOrderList(postData).then(res => {
        if (res.code === 200) {
          let {total, data} = res.data
          this.tableData = data
          this.pagination.total = total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleClickEdit(row){
      this.orderId = row.id
      this.orderEditVisible = true
    },
    handleClickDel(row){
      this.$confirm('确定删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        closeOnPressEscape:false,
        type: 'warning'
      }).then(() => {
        let postData = {
          id:row.id
        }
        adminOrderDel(postData).then(res =>{
          if (res.code === 200) {
            this.$message.success(res.message)
            this.handleClickSearch()
          }
        })
      }).catch(() => {

      });
    },
    handleClickOrderNum(row){
      this.$router.push({
          name:'auth_manage',
          params:{
            keyword:row.order_num
          }
      });

    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },
    // 搜索
    handleClickSearch(){
      this.pagination.pageNum = 1
      this.getTableData()
    },
    // 重置
    handleClickReset(){
      this.searchForm.keyWords = ''
      this.pagination.pageNum = 1
      this.getTableData()
    },

  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
::v-deep .el-icon-search{
  cursor: pointer;
}
::v-deep .inputWidth{
  width: 260px;
}
.kx {
  width: 100%;
  height: 30px;
}
.chart{
  height:540px
}
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 20px;
}

.filed_list{
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}
.danger{
  color: #f02929;
}
.el-icon-more{
  transform: rotate(90deg);
  cursor: pointer;
  vertical-align: middle;
  margin-left: 10px;
}
.el-icon-more:hover{
  color: #1990ff;
}
</style>
